import { render, staticRenderFns } from "./CashDeskPrintTotals.vue?vue&type=template&id=378477e4&scoped=true"
import script from "./CashDeskPrintTotals.vue?vue&type=script&lang=js"
export * from "./CashDeskPrintTotals.vue?vue&type=script&lang=js"
import style0 from "./CashDeskPrintTotals.vue?vue&type=style&index=0&id=378477e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378477e4",
  null
  
)

export default component.exports